import * as React from "react"
import { PropsWithChildren } from "react"

import {
  AddressContainer,
  Contact,
  ContactContainer,
  ContactHeadline,
  ContactInfoContainer,
  ContactSub
} from "./styles"
import { useFooterData } from "../../../hooks/use-footer-data"
import { AddressItem, ContactItem } from "../../core/footer/styles"


export interface ContactConfig {
  title: string;
  subtitle: string;
  locale: string;
  addressLabel: string;
  contactLabel: string;
}

export default function ContactComponent(props: PropsWithChildren<ContactConfig>) {
  const { company } = useFooterData()

  return (
    <Contact>

      <ContactHeadline>{props.title}</ContactHeadline>
      <ContactSub>{props.subtitle}</ContactSub>

      <ContactContainer>
        <AddressContainer>
          <ContactSub>{props.addressLabel}</ContactSub>
          <AddressItem>{company.title}</AddressItem>
          <AddressItem>{company.address.street}</AddressItem>
          <AddressItem>{company.address.place}</AddressItem>
        </AddressContainer>

        <ContactInfoContainer>
          <ContactSub>{props.contactLabel}</ContactSub>
          <ContactItem href={company.tel.href}>{company.tel.value}</ContactItem>
          <ContactItem href={company.email.href}>{company.email.value}</ContactItem>
        </ContactInfoContainer>
      </ContactContainer>

    </Contact>
  )
}
